export enum NotificationType {
  INFO,
  WARNING,
  SUCCESS,
  ERROR
}